import React from "react";
import "./styles.css";
import { useDispatch } from "react-redux";
import { setData } from "ducks/actions";
import FormattedMessage from "components/FormattedMessage/index";

const CompanyDetailsDeclaration = ({
  companyDetails,
  isDeclaredCompanyDetails,
  declarationText = "I declare that the information provided accurately represents the company and that I have obtained authorisation to submit this order on its behalf.",
}) => {
  const dispatch = useDispatch();
  const { 
    company_name:companyName,
    uen:uenNumber,
    company_address:businessAddress
  } = companyDetails;

  const onDeclarationChange = (isDeclaredCompanyDetails) => {
    console.log("value", isDeclaredCompanyDetails)
    dispatch(
      setData({
        key: "isDeclaredCompanyDetails",
        data: {
          isDeclaredCompanyDetails
        }
      })
    );
  }

  return (
    <div className="company-details-container">
      <hr className="company-details-divider" />

      {/* Details Grid */}
      <div className="company-details-grid">
        <div className="detail-item">
          <span className="detail-label">Full company name</span>
          <div className="detail-value">{companyName}</div>
        </div>

        <div className="detail-item">
          <span className="detail-label">UEN number</span>
          <div className="detail-value">{uenNumber}</div>
        </div>

        <div className="detail-item full-width">
          <span className="detail-label">Business address</span>
          <div className="detail-value">{businessAddress}</div>
        </div>
      </div>

      <div className='detail-info-banner'>
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#5c6878"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          style={{ flexShrink: 0 }}
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
        <span>
          <FormattedMessage html id="ent_acra_upload_declare_info" defaultMessage="" />
        </span>
      </div>

      {/* Declaration Checkbox */}
      <label className="declaration-label">
        <input
          type="checkbox"
          className="declaration-checkbox"
          checked={Boolean(isDeclaredCompanyDetails)}
          onChange={(e) => {
            const checked = e.target.checked;
            console.log("CHECKED", checked)
            onDeclarationChange(checked);
          }}
        />
        <span className="custom-checkbox" />
        <span className="declaration-text">
          <FormattedMessage id={'ent_company_declaration_text'} />
        </span>
      </label>
    </div>
  );
};

export default CompanyDetailsDeclaration;